import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SimCardIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SimCardIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={isGradient ? `url(#${gradientId})` : fill}
        d="M3.64971 6.1C3.64971 5.60294 4.05265 5.2 4.54971 5.2H15.2936C15.5317 5.2 15.7602 5.29439 15.9288 5.46249L20.9857 10.5017C21.1552 10.6706 21.2504 10.9 21.2504 11.1392V16.9049C21.2504 17.4019 20.8475 17.8049 20.3504 17.8049H4.54971C4.05265 17.8049 3.64971 17.4019 3.64971 16.9049V6.1ZM4.54971 4C3.38991 4 2.44971 4.9402 2.44971 6.1V16.9049C2.44971 18.0647 3.38991 19.0049 4.54971 19.0049H20.3504C21.5102 19.0049 22.4504 18.0647 22.4504 16.9049V11.1392C22.4504 10.581 22.2282 10.0458 21.8327 9.65172L16.7759 4.61249C16.3823 4.22024 15.8492 4 15.2936 4H4.54971ZM9.97769 11.5023C8.75136 10.2804 7.15819 9.65137 5.55601 9.61383L5.55482 9.61265C5.25856 9.6071 5.02207 9.36204 5.02834 9.06689C5.03462 8.77174 5.27807 8.53864 5.57433 8.5442C7.44314 8.58839 9.30323 9.32324 10.7339 10.7488C12.1647 12.1743 12.9022 14.0277 12.9442 15.8897C12.9509 16.1837 12.7158 16.4274 12.4208 16.4325C12.1257 16.4376 11.881 16.2031 11.873 15.908C11.8353 14.3116 11.204 12.7242 9.97769 11.5023ZM9.18639 15.8001C9.12824 14.9206 8.76223 14.0591 8.08767 13.3867C7.41161 12.7134 6.54698 12.3487 5.66546 12.2919C5.36917 12.2722 5.14331 12.0189 5.16144 11.7238C5.17957 11.4287 5.43252 11.205 5.72881 11.2248C6.86066 11.2976 7.97585 11.7682 8.84331 12.6326C9.71077 13.4969 10.1831 14.608 10.2574 15.737C10.276 16.031 10.0516 16.2854 9.75659 16.3023C9.46158 16.3192 9.20619 16.0953 9.18639 15.8001ZM7.26894 15.2729C7.26974 15.5563 7.15751 15.8278 6.95693 16.0276C6.75636 16.2275 6.48388 16.3393 6.19943 16.3385C5.91499 16.3377 5.64187 16.2243 5.44017 16.0234C5.23847 15.8224 5.12471 15.5503 5.12391 15.2669C5.12311 14.9834 5.23534 14.7119 5.43591 14.5121C5.63648 14.3123 5.90896 14.2004 6.19341 14.2012C6.47786 14.202 6.75098 14.3154 6.95268 14.5163C7.15438 14.7173 7.26814 14.9894 7.26894 15.2729Z"
      />
    </svg>
  );
};

export default SimCardIcon;
